// actions.js

const actions = {
    async fetchData({ commit }) {
      try {
        // Simulate an API call or any asynchronous operation
        const response = await fetch('https://api.example.com/data');
        const data = await response.json();
  
        // Commit a mutation to update the state with the fetched data
        commit('setData', data);
      } catch (error) {
        console.error('Error fetching data:', error);
        // You might want to commit an error mutation or handle errors in some way
      }
    },
  };
  
  export default actions;
  